function _(n,t,o){t.exports=function(){var n=Math.sign;return"function"==typeof n&&(1===n(10)&&-1===n(-20))}}
//# sourceMappingURL=is-implemented.min.js.map